import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { media } from '../theme';

const FooterContainer = styled.footer`
  background: ${props => props.theme.surface};
  border-top: 1px solid ${props => props.theme.border};
  padding: 40px 24px;
  margin-top: 60px;
  text-align: center;
  
  ${media.mobile} {
    padding: 30px 16px;
    margin-top: 40px;
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterText = styled.div`
  color: ${props => props.theme.subText};
  font-size: 14px;
  margin-bottom: 20px;
  
  ${media.mobile} {
    font-size: 12px;
    margin-bottom: 16px;
  }
`;

const FooterSection = styled.div`
  margin-bottom: 30px;
  
  ${media.mobile} {
    margin-bottom: 20px;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 30px;
  justify-content: center;
  align-items: center;
  
  ${media.mobile} {
    gap: 20px;
    flex-direction: column;
  }
`;

const FooterLink = styled(Link)`
  color: ${props => props.theme.primary};
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(247, 147, 26, 0.1);
    transform: translateY(-1px);
  }
  
  ${media.mobile} {
    font-size: 13px;
    padding: 6px 12px;
  }
`;

const StaticPageLink = styled.a`
  color: ${props => props.theme.primary};
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(247, 147, 26, 0.1);
    transform: translateY(-1px);
  }
  
  ${media.mobile} {
    font-size: 13px;
    padding: 6px 12px;
  }
`;

const SocialLink = styled.a`
  color: ${props => props.theme.primary};
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(247, 147, 26, 0.1);
    transform: translateY(-1px);
  }
  
  ${media.mobile} {
    font-size: 13px;
    padding: 6px 12px;
  }
`;

const Footer: React.FC = () => {
  // Generate backend URLs dynamically
  const getBackendUrl = (path: string) => {
    return `${window.location.protocol}//${window.location.hostname}:3001${path}`;
  };

  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterText>
            Data collected from public sources. Updated regularly.
          </FooterText>
          <FooterLinks>
            <FooterLink to="/">Home</FooterLink>
            <StaticPageLink href={getBackendUrl('/about')} target="_blank" rel="noopener noreferrer">
              About Us
            </StaticPageLink>
            <StaticPageLink href={getBackendUrl('/terms')} target="_blank" rel="noopener noreferrer">
              Terms of Service
            </StaticPageLink>
            <SocialLink href="https://twitter.com/proofofprice" target="_blank" rel="noopener noreferrer">
              Twitter / X
            </SocialLink>
            <SocialLink href="https://primal.net/p/nprofile1qqsdrdhnhu76949zjn0zr93992aldfs5h7g2usfkz8kahh5t4pkegug5c9dzr" target="_blank" rel="noopener noreferrer">
              Nostr
            </SocialLink>
          </FooterLinks>
        </FooterSection>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
